module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagKeyAutocomplete.tagKey.label":"Key"}}')
  delete Component.options._Ctor
}
